import { AuthConstants } from 'constants/auth';
import { createAction } from 'redux-actions';

export const signIn = createAction(AuthConstants.AUTH_SIGN_IN);
export const signOut = createAction(AuthConstants.AUTH_SIGN_OUT);
export const updateLastLoginDate = createAction(AuthConstants.UPDATE_LAST_LOGIN_DATE);



// WEBPACK FOOTER //
// ./src/actions/auth.js